<script>
  export let href = '#';
  export let label = '';
  export let variant = 'primary';
  export let fullWidth = false;
  export let target = undefined;
  export let rel = undefined;

  $: className = `button ${variant}${fullWidth ? ' full-width' : ''}`;
</script>

<a class={className} href={href} {target} {rel}>
  <span>{label}</span>
  <span class="button-arrow" aria-hidden="true"></span>
</a>

<style>
  .button {
    display: inline-flex;
    min-height: 44px;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 13px 23px;
    border-radius: 5px;
    font-size: 18px;
    font-weight: 500;
    line-height: 18px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    box-sizing: border-box;
  }

  .full-width {
    width: 100%;
  }

  .primary {
    background: #e7b962;
    color: #000000;
  }

  .secondary {
    background: transparent;
    color: #ffffff;
  }

  .light {
    background: #ffffff;
    color: #000000;
  }

  .button:hover,
  .button:focus-visible {
    text-decoration: none;
  }

  .primary:hover,
  .primary:focus-visible {
    background: #ffffff;
    color: #000000;
  }

  .light:hover,
  .light:focus-visible {
    background: #e7b962;
    color: #000000;
  }

  .secondary:hover,
  .secondary:focus-visible {
    background: rgba(255, 255, 255, 0.08);
    color: #e7b962;
  }

  .button-arrow {
    flex: 0 0 8px;
    width: 8px;
    height: 18px;
    background: currentColor;
    -webkit-mask: url('/icons/ui-icon-chevron-right.svg') center / contain no-repeat;
    mask: url('/icons/ui-icon-chevron-right.svg') center / contain no-repeat;
  }
</style>
